import { graphSettings } from '@/config/settings';
import type { HealthWoundTrendPoint } from '@/domain/health';

/** Palette hex values, so `ChartTheme.color` can lift the ones that need it on the dark card. */
export const WOUND_GRAPH_COLORS = {
    active: graphSettings.fishHealthColors.active,
    healing: graphSettings.fishHealthColors.healing,
    large: graphSettings.fishHealthColors.large,
    medium: graphSettings.fishHealthColors.medium,
    small: graphSettings.fishHealthColors.small,
    single: graphSettings.fishHealthColors.singleWound,
    multiple: graphSettings.fishHealthColors.multipleWounds,
} as const;

export interface WoundGraphSeriesConfig {
    label: string;
    color: string;
    getValue: (point: HealthWoundTrendPoint) => number | null;
}

export function extractWoundTrendDayLabels(points: HealthWoundTrendPoint[]): string[] {
    return points.map((point) => point.day);
}
